// Combined registry of all SEO page content data
import { ASSET_PAGES } from './assetPages';
import { ASSET_PAGES_MORE } from './assetPagesMore';
import { PRODUCT_PAGES } from './productPages';
import { INDUSTRY_PAGES } from './industryPages';

const ALL_SEO_PAGES = {
  ...ASSET_PAGES,
  ...ASSET_PAGES_MORE,
  ...PRODUCT_PAGES,
  ...INDUSTRY_PAGES,
};

export default ALL_SEO_PAGES;

// Export the list of all slugs for sitemap and routing
export const SEO_PAGE_SLUGS = Object.keys(ALL_SEO_PAGES);
